import { ApprovalsResponse, ApprovalStatus } from './../../models/tank-approvals-response.interface';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, signal, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TankApprovalsService } from 'src/app/services/tank-approvals.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalTankApprovals } from '../modals/modal-tank-approvals/modal-tank-approvals';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tank-approvals',
  standalone: true,
  imports: [
    FontAwesomeModule,
    ModalTankApprovals
  ],
  templateUrl: './tank-approvals.html',
  styleUrl: './tank-approvals.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TankApprovals {
  @ViewChild(ModalTankApprovals) modalTankApprovals!: ModalTankApprovals
  tanksService = inject(TankApprovalsService);
  toastr = inject(ToastrService);
  storageService = inject(StorageService);
  icons = inject(IconsService);
  tankId = input<number>();
  user: any;
  roleId = signal<number>(0);
  approvalsResponse = signal<ApprovalsResponse[] | null>(null);
  approvalComplete = model<boolean>(false);

  approvalRoles = computed(() => {
    const approvals = this.approvalsResponse();
    if (approvals === null || !Array.isArray(approvals)) return [];
    return approvals.map(a => a.approver_role_id.id);
  });

  approvalOperationLead = computed<boolean>(() => {
    return this.approvalRoles().includes(14) ? true : false;
  });

  approvalBussinessUnitDirector = computed<boolean>(() => {
    return this.approvalRoles().includes(15) ? true : false;
  });

  approvalAudit = computed<boolean>(() => {
    return this.approvalRoles().includes(16) ? true : false;
  });

  constructor() {
    this.user = this.storageService.getItem(STORAGE_KEYS.USER) ? this.storageService.getItem(STORAGE_KEYS.USER) : null;
    this.roleId.set(this.user.role?.id ? this.user.role.id : this.user.role_id);
    effect(() => {
      const id = this.tankId();
      if (id) {
        this.loadApprovals(id);
      }
    });
    effect(
      () => {
        const roles = this.approvalRoles();

        this.approvalComplete.set(
          roles.includes(14) &&
          roles.includes(15) &&
          roles.includes(16)
        );
      },
      { allowSignalWrites: true }
    );
  }

  loadApprovals(id: number) {
    this.tanksService.getApprovals(id)
      .subscribe({
        next: (response: ApprovalsResponse[]) => {
          this.approvalsResponse.update(() => ([...response]));
        }
      });
  }

  validateOrder() {
    let valid = false;
    switch (this.user.role_id) {
      case 14:
        valid = true;
        break;
      case 15:
        valid = this.approvalRoles().includes(14);
        break;
      case 16:
        valid = this.approvalRoles().includes(14) && this.approvalRoles().includes(15);
        break;
    }

    return valid;
  }

  approve() {
    if ([14,15,16].includes(this.user.role_id)) {
      if ((this.approvalOperationLead() && this.user.role_id === 14) || (this.approvalBussinessUnitDirector() && this.user.role_id === 15) || (this.approvalAudit() && this.user.role_id === 16)) {
        this.toastr.warning('Su rol ya ha aprobado este tanque');
      } else {
        const modalTemplate: any | undefined = this.modalTankApprovals;
      if (modalTemplate) {
        this.modalTankApprovals.openModal(modalTemplate['modalTankApprovalsElem']);
      }
      }
      
    } else {
      this.toastr.error('No tiene permisos para aprobar');
    }
  }

  reload() {
    const id = this.tankId();
    if(id) {
      this.loadApprovals(id);
    }
  }
}
